export const DEFAULT_ENVIRONMENT = 'production';
